// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"856":"3f1b84d8","860":"bc16a4e8"}[chunkId] + ".js";
};